<p-confirmDialog />
<ng-template #newBtn>
  <div class="project-actions">
    <p-button label="Neues Projekt erstellen" i18n-label="@@create-project-desc"
      icon="ri-add-line" styleClass="project-create-button" (click)="newProjectTrigger.emit()" />
    <p-button label="Projekt importieren" i18n-label="@@import-project-button"
      icon="ri-upload-2-line ri" severity="secondary" styleClass="project-import-button"
      (click)="openImportProject()" />
  </div>
</ng-template>
@if (recentBots.length > 0) {
  <section class="recent-bots" aria-labelledby="recent-bots-heading">
    <h5 id="recent-bots-heading" i18n="@@recently-visited-bots">Zuletzt besuchte Bots</h5>
    <div class="recent-bots-list">
      @for (bot of recentBots; track bot._id) {
        <a class="recent-bot" [routerLink]="['/', 'bot-admin', bot._id, botService.getBotDeeplink(bot)]">
          <app-bot-icon [botConfig]="bot" [navigateOnClick]="false" [imageVersion]="imageVersion" />
          <span>{{bot.name}}</span>
        </a>
      }
    </div>
  </section>
}
<app-project-pagehearder />
@if (projectService.projects.length > 0) {
  <div class="project-actions-section">
    <ng-container [ngTemplateOutlet]="newBtn" />
    <app-orgswitcher />
  </div>
}
<p-table [customSort]="true" [sortField]="sortField" [sortOrder]="sortOrder"
  (sortFunction)="sortProjects($event)" [value]="visibleProjects()"
  [rowHover]="projectService.projects.length > 0"
  [tableStyle]="{ 'table-layout': 'fixed', 'width': '100%', 'min-width': '760px' }">
  <ng-template pTemplate="colgroup">
    <colgroup>
      <col style="width: 56px"><col style="width: 28%"><col style="width: 18%">
      <col style="width: 22%"><col><col style="width: 64px">
    </colgroup>
  </ng-template>
  <ng-template #header>
    <tr>
      <th>
        <button type="button" class="project-header-star-toggle" [class.is-active]="isHeaderStarActive"
          [attr.aria-pressed]="isHeaderStarActive"
          [attr.aria-label]="isHeaderStarActive ? headerStarShowAllTooltip : headerStarShowFavoritesTooltip"
          [pTooltip]="isHeaderStarActive ? headerStarShowAllTooltip : headerStarShowFavoritesTooltip"
          tooltipPosition="top" tooltipStyleClass="project-header-star-tooltip" (click)="toggleHeaderStarActive()">
          <i class="ri-star-half-line"></i>
        </button>
      </th>
      <th pSortableColumn="name"><ng-container i18n="@@name">Name</ng-container><p-sortIcon field="name" /></th>
      <th pSortableColumn="area"><ng-container i18n="@@area">Bereich</ng-container><p-sortIcon field="area" /></th>
      <th pSortableColumn="creator"><ng-container i18n="@@project-created-by">Erstellt von</ng-container><p-sortIcon field="creator" /></th>
      <th pSortableColumn="created"><ng-container i18n="@@project-created-date">Erstelldatum</ng-container><p-sortIcon field="created" /></th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template #body let-project>
    <tr>
      <td>
        <div class="project-icon-container">
          <button type="button" class="project-favorite-toggle" [class.is-favorite]="isFavoriteProject(project)"
            aria-label="Favorit" i18n-aria-label="@@project-favorite" [attr.aria-pressed]="isFavoriteProject(project)"
            (click)="toggleFavoriteProject(project)" (mouseenter)="setHoveredFavoriteProject(project._id)"
            (mouseleave)="setHoveredFavoriteProject(null)">
            <i class="project-folder-icon" [class.ri-star-line]="!isFavoriteProject(project)"
              [class.ri-star-fill]="isFavoriteProject(project) && hoveredFavoriteProjectId !== project._id"
              [class.ri-star-off-fill]="isFavoriteProject(project) && hoveredFavoriteProjectId === project._id"></i>
          </button>
        </div>
      </td>
      <td>
        <a class="project-name" [routerLink]="['project', project._id]">{{project | projectName}}</a>
        @if (project.description) { <span class="project-description">{{project.description}}</span> }
      </td>
      <td class="project-metadata">
        @if (project._id === '-') { <span i18n="@@project-personal-area">Persönlich</span> }
        @else { {{project.orgShort}} }
      </td>
      <td class="project-metadata">{{project._id === '-' ? '—' : getUserNameById(project.creator)}}</td>
      <td class="project-metadata">
        @if (project._id === '-') { — }
        @else { <span [title]="dayjs(project.created).format('DD.MM.YYYY HH:mm')">{{dayjs(project.created).fromNow()}}</span> }
      </td>
      <td>
      @if (canShowMenu(project)) {
        <p-popover
          [dismissable]="true"
          #popover
          appendTo="body"
          >
          <div class="flex flex-column">
            @for (item of actionsMenu; track item) {
              <div
                class="flex align-items-center gap-3 py-1 px-2 cursor-pointer popover-hover transition-colors transition-duration-150"
                (click)="item.command(); popover.hide()"
                >
                <i
                  [class]="item.icon"
                  class="text-secondary me-3"
                ></i>
                <span class="text-color">{{ item.label }}</span>
              </div>
            }
          </div>
        </p-popover>
        <p-button
          #btn
          (click)="openMenu($event, popover, project, btn) "
          rounded
          severity="secondary"
          icon="ri ri-more-2-fill"
          styleClass="button-icon"
          />
      }
      </td>
    </tr>
  </ng-template>
<ng-template pTemplate="emptymessage">
  <tr>
    <td
      colspan="6"
      class="text-center p-5 text-muted"
      >
      @if (this.projectService.projects.length === 0) {
        <ng-container
          i18n="@@trash-empty"
          >
          Nichts im Papierkorb.
        </ng-container>
      }
      @if (this.projectService.projects.length > 0) {
        <ng-container
          i18n="@@no-project-found"
          >
          Keine Projekte gefunden. Passe deine Suche an.
        </ng-container>
      }
      <br><br>
      <ng-container [ngTemplateOutlet]="newBtn"></ng-container>
    </td>
  </tr>
</ng-template>
</p-table>